export default __webpack_public_path__ + "static/media/merchant.999b4722.svg";